'use strict';

var _model = require('common/models/base/model');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
*/

module.exports = _model2['default'].extend({

    /**
    */

    ROLE_CODE_ADMIN: 'a',
    ROLE_CODE_DEVELOPER: 'd',
    ROLE_CODE_MEMBER: 'm',
    ROLE_NAMES: {
        'a': 'Admin',
        'd': 'Developer',
        'm': 'Member'
    },

    numTemplates: 0,
    roleCode: 'm',

    mixins: [require('common/models/mixins/model')],

    apiEndpointAlias: 'teamMembers',

    /**
    */

    toData: function toData() {
        return {
            guid: this.guid,
            emailAddress: this.emailAddress,
            roleCode: this.roleCode,
            pending: this.pending,

            // TODO - remove this!!
            csrfToken: this.csrfToken
        };
    },

    /**
    * promotes or demotes a user depending on the new role code
    */

    promote: function promote(newRoleCode, onSave) {
        this.set('roleCode', newRoleCode);
        this.save(onSave);
    },

    /**
    */

    getRoleTypeLabel: function getRoleTypeLabel() {
        return this.ROLE_NAMES[this.roleCode || this.ROLE_CODE_MEMBER];
    },

    /**
    */

    canModifyTeam: function canModifyTeam() {
        return this.isAdmin() || this.isDeveloper();
    },

    /**
    */

    isLoggedInUser: function isLoggedInUser() {

        // ideally we'd go off user ids, but this works for now (CC)
        return this.isUser(this.user);
    },

    /**
    */

    isUser: function isUser(user) {
        if (!user) return false;
        // ideally we'd go off user ids, but this works for now (CC)
        return this.emailAddress === user.emailAddress;
    },

    /**
    */

    equals: function equals(model) {
        return model.guid === this.guid;
    },

    /**
    */

    isAdmin: function isAdmin() {
        return this.roleCode === this.ROLE_CODE_ADMIN;
    },

    /**
    */

    isDeveloper: function isDeveloper() {
        return this.roleCode === this.ROLE_CODE_DEVELOPER;
    },

    /**
    */

    isMember: function isMember() {
        return this.roleCode === this.ROLE_CODE_MEMBER;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/team-member.js
 ** module id = 385
 ** module chunks = 0
 **/